module.exports = __webpack_public_path__ + "static/img/our-customers-infrastructure-row2.a2dcf06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/our-customers-infrastructure-row2.jpg
// module id = yugu
// module chunks = 0